import * as _ from 'lodash';

export const mapParams = (params) => {
  const queryParams = new URLSearchParams();

  const mapValuesDeep = (obj, fn) =>
    _.mapValues(obj, (val, key) =>
      _.isPlainObject(val)
        ? mapValuesDeep(val, fn)
        : fn(val, key, obj)
    );

  mapValuesDeep(params, (value, key) => {
    if (_.isNull(value)) return;

    queryParams.append(key, value);
  });

  return queryParams.toString();
};


// WEBPACK FOOTER //
// ./src/utils/mapParams.js